import React from "react";
import { Flex, Grid, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingCtaButton from "@/features/pathpick/features/landing/components/PathPickLandingCtaButton";
import PathPickLandingProductImage from "@/features/pathpick/features/landing/components/PathPickLandingProductImage";
import { PathPickLandingCta } from "@/features/pathpick/features/landing/hooks/usePathPickLandingCta";
import {
  PATHPICK_LANDING_COLORS,
  PATHPICK_LANDING_IMAGES,
} from "@/features/pathpick/features/landing/constants";

interface Props {
  cta: PathPickLandingCta;
}

function PathPickLandingHero({ cta }: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex
      as={"section"}
      justifyContent={"center"}
      // 고정 헤더 높이만큼 위쪽을 비운다.
      paddingTop={{ base: "96px", lg: "132px" }}
      paddingBottom={{ base: "48px", lg: "72px" }}
      paddingX={{ base: "20px", lg: "40px" }}
    >
      <Grid
        width={"100%"}
        maxWidth={"1120px"}
        templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
        gap={{ base: "36px", lg: "48px" }}
        alignItems={"center"}
      >
        <Flex flexDirection={"column"} gap={"20px"}>
          <Text
            as={"h1"}
            textStyle={"body-lg-bold"}
            fontSize={{ base: "30px", lg: "40px" }}
            lineHeight={{ base: "42px", lg: "56px" }}
            color={PATHPICK_LANDING_COLORS.textStrong}
            whiteSpace={"pre-line"}
          >
            {t("path_pick_landing:hero.title")}
          </Text>
          <Text
            textStyle={"body-md-regular"}
            fontSize={{ base: "15px", lg: "17px" }}
            color={PATHPICK_LANDING_COLORS.textMuted}
          >
            {t("path_pick_landing:hero.description")}
          </Text>
          <Flex>
            <PathPickLandingCtaButton
              action={cta.primary}
              icon={"chevron-right"}
              size={"lg"}
              isPending={!cta.isReady}
            />
          </Flex>
        </Flex>

        {/* 카드 2장이 한 이미지로 묶여 있다. */}
        <Flex justifyContent={{ base: "center", lg: "flex-end" }}>
          <PathPickLandingProductImage
            src={PATHPICK_LANDING_IMAGES.hero.src}
            alt={t("path_pick_landing:hero.image_alt")}
            naturalWidth={PATHPICK_LANDING_IMAGES.hero.width}
            naturalHeight={PATHPICK_LANDING_IMAGES.hero.height}
            isEager
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default PathPickLandingHero;
